import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
const HourScopeContext = createContext();

// Os players de radar e satélite sempre executam um escopo fixo de horas —
// sem seleção na UI.
const RADAR_HOUR_SCOPE = 3;
const SATELLITE_HOUR_SCOPE = 5;

const hourScopeValue = {
  getHourScopeRadar: RADAR_HOUR_SCOPE,
  getHourScopeSatelite: SATELLITE_HOUR_SCOPE,
};

export const HourScopeProvider = ({ children }) => {
  return (
    <HourScopeContext.Provider value={hourScopeValue}>
      {children}
    </HourScopeContext.Provider>
  );
};

export const useHourScope = () => {
  return useContext(HourScopeContext);
};

export const useHourScopeSatelite = () => {
  return useContext(HourScopeContext);
};

HourScopeProvider.propTypes = {
  children: PropTypes.any
}
